import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";

export class PoopItemObject extends Phaser.GameObjects.Image {
  private originalX: number;
  private originalY: number;
  private isDragging: boolean = false;
  private shouldReturn: boolean = true;

  public get dragging(): boolean {
    return this.isDragging;
  }

  public setShouldReturn(value: boolean): void {
    this.shouldReturn = value;
  }

  public stopReturnTween(): void {
    if (this.returnTween) {
      this.returnTween.stop();
      this.returnTween = undefined;
    }
  }

  private returnTween?: Phaser.Tweens.Tween;
  private grabScaleTween?: Phaser.Tweens.Tween;
  private originalScale: number = 0.5;
  private originalDepth: number = 0;

  constructor(
    private myScene: BasicScene,
    x: number,
    y: number,
  ) {
    super(myScene, x, y, myScene.atlas, myScene.keys.assets.sprites.items.poop);

    // Сохраняем исходную позицию
    this.originalX = x;
    this.originalY = y;
    this.originalDepth = this.depth;
    this.setScale(this.originalScale);

    // Отключаем обработчик onClick базового класса, чтобы не конфликтовал с перетаскиванием
    this.off("pointerdown");

    // Делаем объект перетаскиваемым
    this.setInteractive({ useHandCursor: true, draggable: true });

    // Обработчики перетаскивания
    this.on("pointerdown", this.onDragStart.bind(this));
    myScene.input.on("pointermove", this.onDrag.bind(this));
    myScene.input.on("pointerup", this.onDragEnd.bind(this));
  }

  private onDragStart(_pointer: Phaser.Input.Pointer): void {
    if (this.isDragging) return;

    this.isDragging = true;

    // Останавливаем возврат, если он был в процессе
    if (this.returnTween) {
      this.returnTween.stop();
      this.returnTween = undefined;
    }

    // Останавливаем твины масштабирования базового класса
    // this.pauseScaleTweens();

    // Увеличиваем масштаб при захвате
    if (this.grabScaleTween) {
      this.grabScaleTween.stop();
    }
    this.grabScaleTween = this.myScene.tweens.add({
      targets: this,
      scaleX: this.originalScale + 0.2,
      scaleY: this.originalScale + 0.2,
      duration: 200,
      ease: "Power2",
    });

    // Поднимаем объект поверх остальных
    // this.originalDepth = this.depth;
    // this.setDepth(1000);
  }

  private onDrag(pointer: Phaser.Input.Pointer): void {
    if (this.isDragging && pointer.isDown) {
      // Перемещаем объект за курсором
      this.setPosition(pointer.worldX, pointer.worldY);
    }
  }

  private onDragEnd(_pointer: Phaser.Input.Pointer): void {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.shouldReturn = true; // По умолчанию возвращаем на исходную позицию

    // Останавливаем твин увеличения масштаба
    if (this.grabScaleTween) {
      this.grabScaleTween.stop();
      this.grabScaleTween = undefined;
    }

    // Возвращаем масштаб к исходному
    this.myScene.tweens.add({
      targets: this,
      scaleX: this.originalScale,
      scaleY: this.originalScale,
      duration: 200,
      ease: "Power2",
      onComplete: () => {
        // Возобновляем твины масштабирования базового класса после возврата масштаба
        // this.resumeScaleTweens();
      },
    });

    // Плавно возвращаем на исходную позицию (если система не отменила возврат)
    if (this.shouldReturn) {
      this.returnTween = this.myScene.tweens.add({
        targets: this,
        x: this.originalX,
        y: this.originalY,
        duration: 500,
        ease: "Power2",
        onComplete: () => {
          // Возвращаем исходную глубину после возврата
          this.setDepth(this.originalDepth);
          this.returnTween = undefined;
        },
      });
    }
  }

  override destroy(): void {
    // Отписываемся от событий сцены
    if (this.myScene) {
      this.myScene.input.off("pointermove", this.onDrag, this);
      this.myScene.input.off("pointerup", this.onDragEnd, this);
    }

    // Останавливаем твины
    if (this.returnTween) {
      this.returnTween.stop();
    }
    if (this.grabScaleTween) {
      this.grabScaleTween.stop();
    }

    super.destroy();
  }
}
